/** 불규칙 배치 도트 — 흰(적게) + 연·중회색(많게) */
const WHITE_DOTS = [
  ['84', '11', '0.9', '0.62'],
  ['115', '14', '0.75', '0.58'],
  ['79', '35', '0.85', '0.6'],
  ['18', '58', '0.55', '0.55'],
  ['126', '88', '0.7', '0.58'],
  ['162', '74', '0.8', '0.6'],
  ['48', '6', '0.45', '0.52'],
  ['132', '106', '0.65', '0.56'],
] as const

/** cx, cy, r, gray rgb (no white), alpha */
const GRAY_DOTS = [
  ['12', '9', '1.05', '188,194,204', '0.82'],
  ['31', '18', '0.85', '176,182,192', '0.78'],
  ['67', '24', '0.95', '168,174,184', '0.8'],
  ['102', '28', '0.7', '192,198,208', '0.76'],
  ['8', '34', '0.75', '180,186,196', '0.74'],
  ['26', '42', '1.1', '165,171,181', '0.85'],
  ['44', '38', '0.6', '190,196,206', '0.72'],
  ['61', '48', '0.9', '172,178,188', '0.8'],
  ['97', '52', '0.65', '185,191,201', '0.75'],
  ['133', '31', '0.8', '178,184,194', '0.78'],
  ['151', '8', '0.55', '195,200,210', '0.7'],
  ['168', '44', '1.05', '170,176,186', '0.82'],
  ['36', '66', '0.95', '175,181,191', '0.79'],
  ['54', '72', '0.5', '188,194,204', '0.68'],
  ['72', '61', '1', '168,174,184', '0.83'],
  ['108', '65', '0.6', '182,188,198', '0.74'],
  ['144', '56', '0.85', '178,184,194', '0.77'],
  ['6', '82', '0.9', '172,178,188', '0.8'],
  ['42', '88', '1.15', '162,168,178', '0.86'],
  ['60', '102', '0.7', '186,192,202', '0.76'],
  ['78', '94', '0.95', '174,180,190', '0.81'],
  ['96', '108', '0.55', '190,196,206', '0.72'],
  ['114', '98', '1.05', '166,172,182', '0.84'],
  ['150', '82', '0.9', '180,186,196', '0.78'],
  ['168', '100', '0.65', '188,194,204', '0.74'],
  ['22', '14', '0.5', '178,184,194', '0.7'],
  ['55', '52', '0.75', '170,176,186', '0.8'],
  ['88', '42', '0.55', '185,191,201', '0.73'],
  ['121', '72', '0.7', '175,181,191', '0.79'],
  ['154', '22', '0.6', '182,188,198', '0.75'],
  ['3', '48', '0.45', '192,198,208', '0.68'],
  ['17', '76', '0.8', '168,174,184', '0.81'],
  ['39', '54', '0.4', '178,184,194', '0.72'],
  ['58', '19', '0.65', '172,178,188', '0.77'],
  ['73', '103', '0.85', '165,171,181', '0.83'],
  ['91', '3', '0.5', '188,194,204', '0.7'],
  ['105', '41', '0.95', '170,176,186', '0.8'],
  ['128', '63', '0.55', '180,186,196', '0.74'],
  ['141', '95', '0.75', '174,180,190', '0.78'],
  ['159', '57', '0.45', '186,192,202', '0.71'],
  ['171', '17', '0.7', '176,182,192', '0.76'],
  ['14', '102', '0.6', '182,188,198', '0.75'],
  ['33', '29', '0.35', '190,196,206', '0.65'],
  ['49', '85', '0.9', '168,174,184', '0.82'],
  ['66', '68', '0.5', '178,184,194', '0.73'],
  ['85', '99', '0.8', '172,178,188', '0.79'],
  ['103', '12', '0.55', '185,191,201', '0.72'],
  ['119', '79', '1', '166,172,182', '0.85'],
  ['137', '47', '0.65', '180,186,196', '0.77'],
  ['155', '91', '0.4', '188,194,204', '0.69'],
  ['164', '33', '0.85', '170,176,186', '0.8'],
  ['11', '63', '0.7', '175,181,191', '0.78'],
  ['28', '107', '0.55', '182,188,198', '0.74'],
  ['46', '15', '0.95', '168,174,184', '0.81'],
  ['64', '44', '0.45', '186,192,202', '0.7'],
  ['82', '110', '0.75', '174,180,190', '0.77'],
  ['100', '57', '0.5', '178,184,194', '0.72'],
  ['118', '25', '0.9', '172,178,188', '0.8'],
  ['136', '72', '0.6', '180,186,196', '0.76'],
  ['152', '104', '0.85', '165,171,181', '0.83'],
] as const

const circles = [
  ...WHITE_DOTS.map(
    ([cx, cy, r, a]) =>
      `<circle cx="${cx}" cy="${cy}" r="${r}" fill="rgba(255,255,255,${a})"/>`,
  ),
  ...GRAY_DOTS.map(
    ([cx, cy, r, rgb, a]) =>
      `<circle cx="${cx}" cy="${cy}" r="${r}" fill="rgba(${rgb},${a})"/>`,
  ),
].join('')

export const PAYMENT_CARD_DOTS_PATTERN = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="180" height="114" viewBox="0 0 180 114">${circles}</svg>`,
)}")`
